import { render, staticRenderFns } from "./ListCaptureView.vue?vue&type=template&id=0f13cc64&"
import script from "./ListCaptureView.vue?vue&type=script&lang=js&"
export * from "./ListCaptureView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports